var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"expBnrTxt"},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("warning")]),_vm._v("\n    "+_vm._s(_vm.$t('expBnrTxt'))+" "+_vm._s(_vm.ExpBanner)+"\n  ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }